import { Routes } from '@angular/router';
import { AuthenticatedLayoutComponent } from '@core/components/layout/authenticated-layout/authenticated-layout.component';
import { NotFoundComponent } from '@core/pages/not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./core/auth/auth.routes').then(
            (routes) => routes.AUTH_ROUTES,
          ),
      },
    ],
  },
  {
    path: '',
    children: [
      {
        path: '',
        component: AuthenticatedLayoutComponent,
        loadChildren: () =>
          import('./features/features.routes').then(
            (routes) => routes.FEATURES_ROUTES,
          ),
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
